import React, { useState } from "react";
import { Dropdown, Icon, Popup, Ref } from "semantic-ui-react";
import UploadFilesModal from "shared/modals/UploadFilesModal";
import { CloseableContent } from "dyl-components";

const SubControls = ({ popupRef, dropdownItems, isEllipsisActionDisabled }) => {
    const [isOpen, setIsOpen] = useState(false);

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <div className="SubControls">
            <Icon
                className='Profile__controls--less-margin fas fa-fax'
                disabled
                color="white"
            />
            <Popup
                trigger={(
                    <Icon
                        className='Profile__controls--less-margin fas fa-arrow-up-from-bracket'
                        onClick={() => { setIsOpen(isOpen => !isOpen) }}
                                style={{cursor: 'pointer'}}
                    />
                )}
                open={isOpen}
                content={
                    <CloseableContent onClose={()=>setIsOpen(false)}>
                        <UploadFilesModal closeModal={closeModal}/>
                    </CloseableContent>
                }
                position={`bottom right`}
            />
            <Icon
                className="Profile__controls--less-margin fas fa-voicemail"
                disabled
            />
            <Ref innerRef={popupRef}>
                <Dropdown
                    icon={
                        <Icon
                            name="ellipsis vertical"
                            className="Profile__controls"
                            link
                        />
                    }
                    pointing={"top right"}
                    disabled={isEllipsisActionDisabled}
                >
                    <Dropdown.Menu>
                        {dropdownItems}
                    </Dropdown.Menu>
                </Dropdown>
            </Ref>
        </div>
    );
};

export default SubControls;
